import React        from 'react'

const Content = props => {
    return (
        <div className="services-details-container-content">
            { props.children }
        </div>
    )
}

export default Content
